import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Icon, Confirm } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { Cont } from './styled'
import { StdForm } from 'components'
import {
  fetchMainDepartments,
  fetchDepartments,
  fetchUserDepartments,
  deleteSubDepartment
} from 'ducks/roleMan'
import { columns } from '../../AttributeData'
import { btnGray } from 'variables/styles'

import FormAdjustDepartmentUser from './FormAdjustDepartmentUser'

let refTable = React.createRef()

const AdjustDepartmentUser = props => {
  const {
    userDepartments,
    showModal,
    setShowModal,
    modalData,
    setModalData,
    modalTitle,
    setModalTitle,
    modalIsCreate,
    setModalIsCreate,
    showConfirm,
    setShowConfirm,
    deleteId,
    setDeleteId,
    defaultPage,
    setDefaultPage
  } = props
  const defaultExpanded = props.mainDept.map((item,i)=> {
    return false
  })
  return (
    <Cont>
      <StdForm
        fitContent={false}
        title={
          <div>
            Adjust User Department List
            <Icon
              link
              circular
              inverted
              color='teal'
              name='add'
              size='small'
              style={{ marginLeft: '1rem' }}
              onClick={() => showUserDepartmentModal(true, null)}
            />
          </div>
        }
        style={{ width: '80vw' }}
        enableCollapse
      >
        <ReactTable
          ref={r => refTable = r}
          data={props.mainDept}
          defaultExpanded={{defaultExpanded}}
          collapseOnDataChange={false}
          columns={columns.tUserDepartment}
          defaultPageSize={10}
          previousText='previous'
          nextText='next'
          className='-striped -highlight'
          onPageChange={state => {props.setDefaultPage(state)}}
          page={defaultPage}
          SubComponent={row => {
            return (
              <div style={{ padding: '1rem', width: '70vw' }}>
                <ReactTable
                  data={row.original.items}
                  columns={columns.tMainDepartment}
                  defaultPageSize={5}
                  SubComponent={row => {
                    return (
                      <div style={{ padding: '1rem', width: '70vw' }}>
                        <ReactTable
                          data={row.original.items}
                          columns={columns.tSubDepartment}
                          defaultPageSize={5}
                          getTdProps={(state, rowInfo, column) => {
                            if (!column.Header) {
                              return {
                                onClick: (e, handleOriginal) => {
                                  props.setDeleteId(null)
                                  if(e.target.nodeName === 'I'){
                                    props.setDeleteId(rowInfo.original.id)
                                    setShowConfirm(true)
                                  }
                                }
                              }
                            } else {
                              return {}
                            }
                          }}
                        />
                      </div>
                    )
                  }}
                />
              </div>
            )
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                if (!column.Header) {
                  state.expanded[rowInfo.index] = !state.expanded[
                    rowInfo.index
                  ]
                }
                if (handleOriginal) {
                  handleOriginal()
                }
              },
              style: {
                background: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? btnGray
                    : 'initial'
                  : null,
                color: rowInfo
                  ? state.expanded[rowInfo.index]
                    ? '#fff'
                    : 'initial'
                  : null
              }
            }
          }}
        />
      </StdForm>
      {showModal.userDepartment ? (
        <FormAdjustDepartmentUser
          title={modalTitle}
          data={modalData}
          isCreate={modalIsCreate}
          show={showModal.userDepartment}
          tablePageSize={refTable ? refTable.state.pageSize : 5}
          setCurrentPage={props.setDefaultPage}
          changeShow={() =>
            setShowModal({
              ...showModal,
              userDepartment: !showModal.userDepartment
            })
          }
        />
      ) : null}
      <Confirm
        size='mini'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => onDeleteRoleClick()}
      />
    </Cont>
  )

  function showUserDepartmentModal(isCreate, data) {
    if (isCreate) {
      setModalIsCreate(true)
      setModalTitle('Create User Department')
      setModalData(null)
    } else {
      setModalIsCreate(false)
      setModalTitle('Update User Department')
      setModalData(data)
    }
    setShowModal({ ...showModal, userDepartment: true })
  }

  function onDeleteRoleClick() {
    props.deleteSubDepartment(props.deleteId)
    setShowConfirm(false)
  }
}

const mapStateToProps = (state, props) => {
  function groupDept() {
    let userDept = []
    // FIXME: Low Preformance && FIX Rerender on Cancel
    state.roleMan.userDepartments.forEach(item => {
      item.items.forEach(item => {
        item['mainDepartmentName'] = state.roleMan.departments.find(item2 =>
          item2.mainDepartmentCode === item.mainDepartment &&
          item2.subDepartmentCode === item.subDepartment
            ? (item['subDepartmentName'] = item2.subDepartmentName)
            : null
        ).mainDepartmentName
      })
      let mainDeptCode = item.items.map(i => i.mainDepartment),
        items = []
      mainDeptCode = mainDeptCode.filter(
        (item, index) => mainDeptCode.indexOf(item) === index
      )
      mainDeptCode.forEach(item => {
        items.push({
          mainDepartmentCode: item,
          mainDepartmentName: state.roleMan.mainDepartments.find(
            dept => dept.departmentCode === item
          ).departmentName,
          items: []
        })
      })
      items.forEach(a => {
        item.items.forEach(b => {
          if (a.mainDepartmentCode === b.mainDepartment) {
            a.items.push(b)
          }
        })
      })
      userDept.push({
        fullName: item.fullName,
        modifiedBy: item.modifiedBy,
        modifiedDate: item.modifiedDate,
        username: item.username,
        items: items
      })
    })
    return userDept
  }
  return {
    departments: state.roleMan.departments,
    userDepartments: state.roleMan.userDepartments,
    mainDepartments: state.roleMan.mainDepartments,
    mainDept: groupDept()
  }
}

const mapDispatchToProps = {
  fetchMainDepartments,
  fetchDepartments,
  fetchUserDepartments,
  deleteSubDepartment
}

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('showModal', 'setShowModal', {
    role: false,
    userDepartment: false
  }),
  withState('modalIsCreate', 'setModalIsCreate', false),
  withState('modalData', 'setModalData', null),
  withState('modalTitle', 'setModalTitle', ''),
  withState('showConfirm', 'setShowConfirm', false),
  withState('deleteId', 'setDeleteId'),
  withState('defaultPage', 'setDefaultPage', 0),
  lifecycle({
    componentDidMount() {
      this.props.fetchMainDepartments()
      this.props.fetchDepartments()
      this.props.fetchUserDepartments()
    },
    componentWillReceiveProps(nextProp) {}
  })
)

export default enhance(AdjustDepartmentUser)
